<input
  [ng2TelInputOptions]="ng2TelInputOptions"
  ng2TelInput
  matInput
  appPhoneNumber
  [placeholder]="placeholder"
  (intlTelInputObject)="telInputObject($event)"
  [value]="tel"
  (input)="onTelInput()"
  (click)="onContainerClick()"
  #input
  [required]="required"
  [readonly]="readonly"
/>
